/*
 * DasboardFilters Messages
 *
 * This contains all the text for the DasboardFilters component.
 */
import { defineMessages } from 'react-intl';
import { DASHBOARD } from '@config/modelsConfig';

const messages = {
  [DASHBOARD.FILTER.FROM_DATE]: {
    id: 'CONFERENCE_CALLS_FILTER.from_date',
    defaultMessage: 'From',
  },
  [DASHBOARD.FILTER.TO_DATE]: {
    id: 'CONFERENCE_CALLS_FILTER.to_date',
    defaultMessage: 'To',
  },
  filter: {
    id: 'CONFERENCE_CALLS_FILTER.filter',
    defaultMessage: 'Filter',
  },
  [DASHBOARD.FILTER.ANALYST]: {
    id: 'CONFERENCE_CALLS_FILTER.analyst',
    defaultMessage: 'Assigned to',
  },
  email: {
    id: 'CONFERENCE_CALLS_FILTER.email',
    defaultMessage: 'Email',
  },
};

export default defineMessages(messages);



// WEBPACK FOOTER //
// ./components/molecules/DashboardFilters/messages.js